import { routingUrls } from '@doltech/core/lib/routing/routing.config';
import { formatDiffDate } from '@doltech/utils/lib/date';
import moment from 'moment';
import * as React from 'react';
import { ReactElement } from 'react';

import { useUserAuthentication } from '../../figma/Auth/hocs/withUserAuthentication';
import { colorsV2 } from '../../figma/colors-v2';
import astronautImg2 from '../img/astronaut-banner-2.png';
import astronautImg3 from '../img/astronaut-banner-3.png';
import astronautImg4 from '../img/astronaut-banner-4.png';
import { DolPremiumNoImageBanner } from './DolPremiumNoImageBanner';
import { DolPremiumVerticalBanner } from './DolPremiumVerticalBanner';
import { DolPremiumWithImageBanner } from './DolPremiumWithImageBanner';

interface DolPremiumBannerProps {
  hasImage?: boolean;
  vertical?: boolean;

  backgroundColor: string;
  title: string;
  description: ReactElement;

  actionTitle: string;
  actionHref?: string;
  actionOnClick?: () => void;
  actionBackgroundColor: string;

  hrefOptions?: any;
  bannerImg: string;
}

export const DolPremiumBanner = ({
  hasImage = true,
  vertical = false,
  ...props
}: DolPremiumBannerProps) => {
  if (hasImage) {
    return <DolPremiumWithImageBanner {...props} />;
  }

  if (vertical) {
    return <DolPremiumVerticalBanner {...props} />;
  }

  return <DolPremiumNoImageBanner {...props} />;
};

export const ExpireSoonPromotion = ({ hasImage = true, expireAt, vertical = false }) => {
  const expDate = moment(expireAt).valueOf();

  return (
    <DolPremiumBanner
      hasImage={hasImage}
      vertical={vertical}
      backgroundColor={colorsV2.yellow10}
      title="Gần hết hạn"
      description={
        <>
          Tài khoản DOL Pro của bạn chỉ còn {formatDiffDate(Date.now(), expDate)}. Hãy gia hạn để
          tránh làm gián đoạn việc học nhé !
        </>
      }
      actionTitle="Gia hạn tài khoản"
      actionHref={routingUrls.landing.STUDENT_VIEW_MY_ACCOUNT}
      actionBackgroundColor={colorsV2.yellow100}
      bannerImg={astronautImg2}
    />
  );
};

export const ExpiredPromotion = ({ hasImage = true, vertical = false }) => (
  <DolPremiumBanner
    hasImage={hasImage}
    vertical={vertical}
    backgroundColor={colorsV2.primary10}
    title="Hết hạn sử dụng"
    description={<>Tài khoản DOL Pro của bạn đã hết hạn. Hãy gia hạn để tiếp tục việc học nhé !</>}
    actionTitle="Gia hạn tài khoản"
    actionHref={routingUrls.landing.STUDENT_VIEW_MY_ACCOUNT}
    actionBackgroundColor={colorsV2.primary100}
    bannerImg={astronautImg3}
  />
);

export const RegisterAccPromotion = ({ hasImage = true, vertical = false }) => {
  const { openLoginModal } = useUserAuthentication();
  return (
    <DolPremiumBanner
      hasImage={hasImage}
      vertical={vertical}
      backgroundColor={colorsV2.primary10}
      title="Đăng ký tài khoản"
      description={
        <>
          Bằng việc đăng ký tài khoản, bạn có quyền truy cập toàn bộ các tính năng premium của DOL.{' '}
        </>
      }
      actionTitle="Sign up free"
      actionOnClick={() => openLoginModal({})}
      actionHref={routingUrls.landing.STUDENT_VIEW_MY_ACCOUNT}
      actionBackgroundColor={colorsV2.primary100}
      bannerImg={astronautImg4}
    />
  );
};
